<div class="statementModal alert-msg-frame">
  <div class="modal-body p-0">
    <!--X-->
    <div class="row">
      <div class="col-md-12">
        <div style="color: white; padding-top: 43px;">
          <!--  <i class="icon icon-add pull-right close-icon-x" ng-click="$close(false)"  style="font-size: 40px;"></i> -->
        </div>
      </div>
    </div>
    <!--END X-->
    <div class="row">
      <div class="col-md-2 col-sm-3 col-xs-2">
        <i class="icon alert-icon icon-warning alert-icon-f"></i>
      </div>
      <div class="col-md-10 col-sm-9 col-xs-10">
        <span ng-if="vm.data.text" class="logout-modal-header-2">Test</span>
        <span ng-if="!vm.data.text" class="c-white alert-msg" translate="alert.cardActivationInfo"></span>
        <input class="form-control input-field" minlength="4" maxlength="4" id="last4Digits" type="text" ng-model="vm.last4Digits" placeholder="{{'alert.cardActivationPlaceholder' | translate}}">
      </div>
    </div>
  </div>
  <div class="modal-footer modal-footer-padding">
    <button ng-disabled="vm.last4Digits == '' || vm.last4Digits.length != 4" class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(vm.last4Digits)"
            translate="alert.confirm">Confirm
    </button>
    <!-- <button class="btn btn-primary-red pull-right statementBtnClose logout-btns" ng-click="$close(false)"
            translate="alert.no">No
    </button> -->
  </div>
</div>
